"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireWildcard(require("react"));
var _useTheme = require("../../theme/utils/useTheme");
var _DragHandleIconWrapper = require("./styled/DragHandleIconWrapper");
var _DraggableItemStyled = require("./styled/DraggableItemStyled");
const DraggableItem = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    children,
    className,
    clientId,
    dragHandleIconProps,
    isDisabled = false,
    isDragging,
    tabIndex = 0,
    ...rest
  } = _ref;
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  const [isActive, setIsActive] = (0, _react.useState)(false);
  const onMouseLeave = e => {
    if (!isDisabled) {
      setIsHovered(false);
      setIsActive(false);
    }
    rest.onMouseLeave?.(e);
  };
  const onMouseEnter = e => {
    if (!isDisabled) {
      setIsHovered(true);
    }
    rest.onMouseEnter?.(e);
  };
  const onMouseDown = e => {
    if (!isDisabled) {
      setIsActive(true);
    }
    rest.onMouseDown?.(e);
  };
  const onMouseUp = e => {
    if (!isDisabled) {
      setIsActive(false);
    }
    rest.onMouseUp?.(e);
  };
  const eventHandlers = {
    onMouseEnter,
    onMouseLeave,
    onMouseDown,
    onMouseUp
  };
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const styleProps = {
    isActive,
    isDisabled,
    isDragging,
    isHovered,
    themeMode
  };
  const shouldRenderDragHandle = !isDisabled && (isHovered || isActive || isDragging);
  return /*#__PURE__*/_react.default.createElement(_DraggableItemStyled.DraggableItemStyled, (0, _extends2.default)({}, rest, {
    "aria-disabled": isDisabled,
    "data-client-id": clientId,
    className: className,
    ref: ref,
    tabIndex: tabIndex
  }, styleProps, eventHandlers), /*#__PURE__*/_react.default.createElement(_DragHandleIconWrapper.DragHandleIconWrapper, null, /*#__PURE__*/_react.default.createElement(_ursaIcons.DragHandleIcon, (0, _extends2.default)({}, dragHandleIconProps, {
    style: {
      visibility: shouldRenderDragHandle ? "visible" : "hidden"
    }
  }))), children);
});
exports.DraggableItem = DraggableItem;
DraggableItem.displayName = "DraggableItem";
//# sourceMappingURL=DraggableItem.js.map